/**
 * Cross-component directive events, carried on the app's mitt bus.
 *
 * Lives here rather than in either component so the page and the nav badge
 * share a name without importing each other.
 */

/**
 * A directive record set changed — signed, re-authorized, confirmed, revoked,
 * deleted, or simply reloaded. Listeners should refetch whatever they derive
 * from it; the event carries no payload on purpose, so a listener can never
 * drift out of sync with the server by trusting a diff.
 */
export const DIRECTIVES_CHANGED = "directives:changed";
